var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRestore = function SvgRestore(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.296.976C8.756-1.034 4.227.16 2.182 3.642a7.16 7.16 0 0 0-.928 4.603L1.172 8.2a.79.79 0 0 0-1.067.282.765.765 0 0 0 .287 1.053l1.723.979a.79.79 0 0 0 1.067-.282l.994-1.694a.765.765 0 0 0-.286-1.054.79.79 0 0 0-1.067.282l-.043.074a5.64 5.64 0 0 1 .755-3.425c1.613-2.746 5.186-3.689 7.98-2.102 2.794 1.586 3.75 5.097 2.138 7.841-1.612 2.746-5.185 3.689-7.98 2.102a.79.79 0 0 0-1.067.282.765.765 0 0 0 .287 1.054c3.54 2.01 8.068.818 10.113-2.665 2.046-3.485.831-7.94-2.71-9.95",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRestore);
export { ForwardRef as ReactComponent };